import React from "react";

import { Chip } from "@mui/material";

import {
  CreateOrUpdateResponseUser_Status,
  CreateOrUpdateUsersJob_Status,
} from "@safetyculture/s12-apis-connect-web/s12/users/v1/create_or_update_pb";

import {
  formatJobStatus,
  formatUserStatus,
} from "components/org-user-jobs/helpers";

type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "error"
  | "info";

const JOB_STATUS_COLORS: Record<CreateOrUpdateUsersJob_Status, ChipColor> = {
  [CreateOrUpdateUsersJob_Status.UNSPECIFIED]: "default",
  [CreateOrUpdateUsersJob_Status.PENDING]: "default",
  [CreateOrUpdateUsersJob_Status.ERRORED]: "error",
  [CreateOrUpdateUsersJob_Status.VALIDATING]: "info",
  [CreateOrUpdateUsersJob_Status.VALIDATED]: "success",
  [CreateOrUpdateUsersJob_Status.VALIDATED_WITH_ERRORS]: "warning",
  [CreateOrUpdateUsersJob_Status.EXECUTING]: "info",
  [CreateOrUpdateUsersJob_Status.COMPLETED]: "success",
  [CreateOrUpdateUsersJob_Status.COMPLETED_WITH_ERRORS]: "warning",
  [CreateOrUpdateUsersJob_Status.CANCELLED]: "default",
};

const USER_STATUS_COLORS: Record<CreateOrUpdateResponseUser_Status, ChipColor> =
  {
    [CreateOrUpdateResponseUser_Status.UNSPECIFIED]: "default",
    [CreateOrUpdateResponseUser_Status.PENDING]: "default",
    [CreateOrUpdateResponseUser_Status.ERRORED]: "error",
    [CreateOrUpdateResponseUser_Status.VALIDATED]: "success",
    [CreateOrUpdateResponseUser_Status.VALIDATED_WITH_ERRORS]: "warning",
    [CreateOrUpdateResponseUser_Status.COMPLETED]: "success",
    [CreateOrUpdateResponseUser_Status.COMPLETED_WITH_ERRORS]: "warning",
  };

interface JobStatusChipProps {
  status: CreateOrUpdateUsersJob_Status;
}

export const JobStatusChip = ({ status }: JobStatusChipProps) => (
  <Chip
    size="small"
    label={formatJobStatus(status)}
    color={JOB_STATUS_COLORS[status] ?? "default"}
    data-testid={`job-status-chip-${status}`}
  />
);

interface UserStatusChipProps {
  status: CreateOrUpdateResponseUser_Status;
}

export const UserStatusChip = ({ status }: UserStatusChipProps) => (
  <Chip
    size="small"
    label={formatUserStatus(status)}
    color={USER_STATUS_COLORS[status] ?? "default"}
    data-testid={`user-status-chip-${status}`}
  />
);
